// 
import WebComponent from '../webComponents/WebComponent';

export default class FileInput extends WebComponent {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.fileInput = null;
    this.button = null;
    this.result = null;
  }

  didMount() {
    this.fileInput = this.element.querySelector('input'),
    this.button = this.element.querySelector('label'),
    this.result = this.element.querySelector('.form-group__name');

    this.button.addEventListener('click', this.handleClick);
    this.fileInput.addEventListener('change', this.handleChange);
  }

  willUnMount() {
    this.button.removeEventListener('click', this.handleClick);
    this.fileInput.removeEventListener('change', this.handleChange);
    this.fileInput = null;
    this.button = null;
    this.result = null;
  }

  handleClick() {
    this.fileInput.focus();
  }
  handleChange() {
    this.result.innerHTML = this.fileInput.value;
  }
}



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/components/FileInput.js